import React, {ReactNode} from 'react';
import Spin from '@basicComponents/spin';
import DigitBall from '@/common-pages/pick-digit/components/digit-ball';

type Align = 'left' | 'center' | 'right';
const cellClass = (align: Align = 'center') => {
  const textDirection = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };
  return `py-2 px-3 text-t2 ${textDirection[align]}`;
};
export const digitCell = (text: string) => {
  if (!text) return null;
  const strList = text.split('');
  const colors = ['A', 'B', 'C'];
  return (
    <div className="flex items-center gap-1 justify-end">
      {strList.map((item, index) => {
        const color = colors[index];
        return (
          <DigitBall color={color} digit={item} ballSize={24} key={index} />
        );
      })}
    </div>
  );
};
type TableProps = {
  dataSource: any[];
  key?: string;
  loading?: boolean;
  columns: {
    title: string | ReactNode;
    key: any;
    align: Align;
    width?: number | string;
    render?: (data: any, record: any) => React.ReactNode;
  }[];
};

function ResultTable(props: TableProps) {
  const {dataSource, columns, key = 'key', loading = false} = props;
  return (
    <Spin loading={loading}>
      <table className="w-full rounded-lg overflow-hidden">
        <thead>
          <tr className="bg-[#e9ecf5]">
            {columns.map((item, i) => {
              return (
                <td
                  key={item.key || i}
                  className={cellClass(item.align)}
                  style={{width: item.width || 'auto'}}>
                  {item.title}
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {dataSource.map((item, sourceId) => {
            return (
              <tr
                key={item[key] || sourceId}
                className={`${
                  sourceId % 2 === 0 ? 'bg-white' : 'bg-[#F8F9FF]'
                }`}>
                {columns.map((col, colIndex) => {
                  return (
                    <td
                      key={col.key || colIndex}
                      className={cellClass(col.align)}>
                      {col.render
                        ? col.render(item[col.key], item)
                        : item[col.key]}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Spin>
  );
}

export default ResultTable;
